export const isLandscape = () => {
  return window.matchMedia("(orientation:landscape)").matches;
};
